import { getCookie } from '@visa/lib-cookie';
import { getItem } from '../../src/helpers/local-storage';
import { getUsername } from '../../src/helpers/rememberme-cookie-helper';
import { getUsernameFromErmCookie } from '../../src/lib/ssi-erm/check-erm';
import { getUsernameFromSsiCookie } from '../../src/lib/ssi-erm/check-ssi';

/**
 * Check if a given cookie exists
 * @param {*} name
 * @returns {boolean}
 */
export const cookieExist = name => document.cookie.includes(`${name}=`);

/**
 * Grab username from one of these cookies -- remember_me, ssiEnabled, or ermEnabled
 * @returns {string}
 */
export const getUsernameFromCookie = () =>
  getUsername() || getUsernameFromSsiCookie() || getUsernameFromErmCookie() || 'undefined';

/**
 * Get stay signed in status
 * @returns {string} returns "undefined", "OPTED_IN" or "OPTED_OUT"
 */
export const getSsiStatus = () => {
  let status = 'undefined';

  if (cookieExist('ssiEnabled')) {
    status = 'OPTED_IN';
  } else if (cookieExist('ssiDeclined')) {
    status = 'OPTED_OUT';
  }

  return status;
};

/**
 * Check if localStorage "startingTab" key is present
 * @returns {boolean}
 */
export const isLocalStorageStartingTabPresent = () => {
  try {
    return Boolean(getItem('startingTab'));
  } catch (err) {
    return false;
  }
};

/**
 * Check if "alwaysRemember" cookie is present
 * @returns {boolean}
 */
export const isAlwaysRememberCookiePresent = () => {
  return getCookie('alwaysRemember') === 'true';
};

export const getUserType = () => {
  const userRemembered =
    isLocalStorageStartingTabPresent() ||
    cookieExist('remember_me') ||
    cookieExist('_art') ||
    cookieExist('username');
  const isRecognizedUsername = cookieExist('remember_me') || cookieExist('username');

  return userRemembered
    ? isRecognizedUsername
      ? 'Recognized-Username'
      : 'Recognized'
    : 'Unrecognized';
};
